<div class="top">
  <span>{{ data?.error?.title || 'An error occured' }}</span>
</div>
<div class="middle">
  {{ data?.error?.body || '' }}
</div>
<div class="bottom">
  <button mat-button mat-dialog-close>Ok</button>
</div>
